import React from 'react';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import {
  Form,
  Modal,
  Checkbox,
  Input,
} from "antd"

const SignUp = Form.create({ name: 'form_in_modal' })(
  // eslint-disable-next-line
  class extends React.Component {
    state = {
      checkSurvey: [],
      viewModalVisible: false,
      survey_title: '',
      options: [],
      autocomplete_input: '',
      key: 0,
      selected_survey: [],
      description: '',
      phone: '61',
    }


    componentDidUpdate(prevProps, prevState) {
      if (prevState.description !== this.state.description) {
        this.props.form.setFieldsValue({
          description: this.state.description
        })
      }
      if (prevProps.visible !== this.props.visible) {
        this.setState({ description: '', phone: '61', })
      }
    }


    handleCKChange = (event, editor) => {
      const data = editor.getData();
      this.props.form.setFieldsValue({
        description: data
      })
      this.setState({
        description: data
      })
    }

    validatePhoneNumber = (rule, value, callback) => {
      if (value.length < 11 || value.length > 12) {
        callback('Please provide a valid mobile number');
      } else {
        if (value[2] === '0' && value.length === 11) {
          callback('Please provide a valid mobile number');
        } else if (value[2] !== '0' && value.length === 12) {
          callback('Please provide a valid mobile number');
        } else {
          callback();
        }
      }
    }

    InputTel = (value) => {
      this.setState({
        phone: value
      })
    }

    handleCreateUser = () => {
      const { onSubmit, form } = this.props
      form.setFieldsValue({
        phone: this.state.phone,
      })
      onSubmit()
    }

    handleClose = () => {
      const { onClose } = this.props
      onClose()
      // form.setFieldsValue({
      //   terms: undefined,
      // })
    }



    render() {
      const {
        form,
        visible,
      } = this.props;

      const { getFieldDecorator } = form;
      const client_option = [
        { label: 'Individual clients, and keep their results separate from other clients', value: '1' },
        { label: 'Groups of clients, and combine the results to see trends', value: '2' },
      ];

      return (
        <div>
          <Modal
            onCancel={this.handleClose}
            onOk={this.handleCreateUser}
            visible={visible}
            title={'User Registration'}
            width="50%"
          >
            <Form layout="vertical">
              <strong>Your details</strong>
              <p style={{marginTop: '10px'}}>These details are required to create your secure credentials with multi factor authentication. </p>
              <Form.Item label="Name">
                {getFieldDecorator('name', {
                  rules: [{ required: true, message: 'Your name is required' }],
                })(<Input />)}
              </Form.Item>

              <Form.Item label="Email">
                {getFieldDecorator('email', {
                  rules: [{
                    type: 'email',
                    message: 'Please provide a valid email address',
                  }, {
                    required: true,
                    message: 'Please provide a valid email address'
                  }],
                })(<Input />)}
              </Form.Item>
              
              <Form.Item label="Mobile number">
                <PhoneInput
                  country={'au'}
                  autoFormat={false}
                  countryCodeEditable={false}
                  inputStyle={{ width: '100%' }}
                  onChange={this.InputTel}
                  value={this.state.phone}
                />
                {getFieldDecorator('phone', {
                  rules: [
                    {
                      required: true,
                      message: 'Please provide a valid mobile number',
                    },
                    {
                      validator: this.validatePhoneNumber,
                    },
                  ],
                })(<Input type="hidden" />)}
              </Form.Item>

              <strong>About your organisation</strong>
              <Form.Item style={{marginTop: '10px'}} label="Organisation name">
                {getFieldDecorator('organisation', {
                  rules: [{ required: true, message: 'An organisation name is required' }],
                })(<Input />)}
              </Form.Item>
              <Form.Item label="We send assessments or surveys to: ">
                {getFieldDecorator('clients', {
                  rules: [{ required: true, message: 'Please select the option(s) that best describe your organisation' }],
                })(<Checkbox.Group options={client_option} />)}
              </Form.Item>

              <Form.Item label="Tell us a bit more about your organisation and how you think could use MeazureApp">
                {getFieldDecorator('description', {
                  rules: [],
                  valuePropName: 'data',
                  getValueFromEvent: (event, editor) => {
                    const data = editor.getData();
                    return data;
                  },
                  initialValue: ''
                })(<CKEditor
                  editor={ClassicEditor}
                  config={{
                    toolbar: ['heading', '|', 'bold', 'italic', 'blockQuote', 'link', 'numberedList', 'bulletedList', 'insertTable',
                      'tableColumn', 'tableRow', '|', 'undo', 'redo']
                  }}
                  onChange={this.handleCKChange}
                />)}
              </Form.Item>
              
              <strong>MeazureApp terms and conditions of use</strong>
              <p style={{marginTop: '10px'}}>Please read these <a target="_blank" rel="noopener noreferrer" href="https://combase.com.au/meazureapp-terms-and-conditions-of-use/">terms and conditions (the 'Terms')</a> carefully. </p>
              <Form.Item style={{marginBottom: '5px'}} label="By using, browsing and/or reading the Website, this signifies that you have read, understood and agree to be bound by the Terms. If you do not agree with the Terms, you must cease usage of the Website, or any of Services, immediately.">
                {getFieldDecorator('terms', {
                  rules: [{required: true, message: "You must read and agree to the 'Terms' to continue"}],
                })(<Checkbox.Group options={[{label: 'I have read, understood and agree to be bound by the Terms.', value: '1'}]}></Checkbox.Group>)}
              </Form.Item>
              <Form.Item>
                {getFieldDecorator('contact', {
                  rules: [{required: true, message: "We cannot give you access to the application without contacting you"}],
                })(<Checkbox.Group options={[{label: 'I consent to Combase contacting me in relation to this product.', value: '1'}]}></Checkbox.Group>)}
              </Form.Item>
              <p>If you have trouble completing this registration please <a target="_blank" rel="noopener noreferrer" href="https://combase.com.au/contact/">contact us via our website</a>.</p>
            </Form>

          </Modal>

        </div>
      );
    }
  },
);

export default SignUp